module.exports = __webpack_public_path__ + "static/media/login-background@3x.1472e893.jpg";